import { Injectable } from '@angular/core';
import { MessageService } from './message.service';

/**
 * æ­£ä¸æ¹èªå¨éèçæç¤ºæ¡
 */
@Injectable()
export class NecToast {

  constructor(
    private messageService: MessageService
  ) { }

  /**
   * æåæç¤ºæ¡
   */
  success(msg: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      detail: msg
    });
  }

  /**
   * è­¦åæç¤ºæ¡
   */
  warning(msg: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'warn',
      detail: msg
    });
  }

  /**
   * æ¥éæç¤ºæ¡
   */
  error(msg: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'error',
      detail: msg
    });
  }
}
